import { render, staticRenderFns } from "./SendOfferDifferentPrice.vue?vue&type=template&id=08e61e2c"
import script from "./SendOfferDifferentPrice.vue?vue&type=script&lang=js"
export * from "./SendOfferDifferentPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports